// src/components/common/Wizard/reducer.js

const addToSet = (array, value) => [...new Set([...array, value])];

export const wizardReducer = (state, action, steps) => {
  switch (action.type) {
    /* Go to a specific step */
    case 'GOTO': {
      const targetIndex = steps.findIndex((step) => step.id === action.id);
      if (targetIndex === -1) return state;

      const isForward = targetIndex > state.currentIndex;
      const completed = isForward ? addToSet(state.completed, state.currentId) : state.completed;

      const visited = new Set(state.visited).add(action.id);

      return {
        ...state,
        currentId: action.id,
        currentIndex: targetIndex,
        visited,
        completed,
        canProceed: false,
      };
    }

    /*  Next step  */
    case 'NEXT': {
      const nextIndex = Math.min(state.currentIndex + 1, state.total - 1);
      const nextId = steps[nextIndex].id;

      return {
        ...state,
        currentId: nextId,
        currentIndex: nextIndex,
        visited: new Set(state.visited).add(nextId),
        completed: addToSet(state.completed, state.currentId),
        canProceed: false,
      };
    }

    /*  Previous step  */
    case 'PREV': {
      const prevIndex = Math.max(state.currentIndex - 1, 0);
      const prevId = steps[prevIndex].id;

      return {
        ...state,
        currentId: prevId,
        currentIndex: prevIndex,
      };
    }

    /*  Various flags ──────────── */
    case 'STEP_VALID':
      return { ...state, canProceed: action.valid };

    case 'STEP_COMPLETED':
      return {
        ...state,
        completed: addToSet(state.completed, action.id),
      };

    default:
      return state;
  }
};
